"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var R = _interopRequireWildcard(require("ramda"));

var _emotionTheming = require("emotion-theming");

var _styledSystem = require("styled-system");

require("@influitive/infl-fonts/fonts.css");

var _aliases = _interopRequireDefault(require("./aliases"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var extend = R.reduce(R.mergeDeepRight, {});
var sides = {
  admin: {
    colors: {
      primary: '#1883C7'
    }
  },
  advocate: {
    colors: {}
  }
};
/* stylelint-disable font-family-no-missing-generic-family-keyword */

var Base = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "e1281gho0"
})("*,*::before,*::after{box-sizing:border-box;}hr{box-sizing:content-box;height:0;overflow:visible;}font-family:", (0, _styledSystem.themeGet)('fonts.family.0'), ",\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\";font-size:1rem;font-weight:normal;line-height:1.5;div[class^='Page__Container-']{width:100% !important;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90aGVtZS1wcm92aWRlci9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUEwQjBCIiwiZmlsZSI6Ii4uLy4uL3NyYy90aGVtZS1wcm92aWRlci9pbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgKiBhcyBSIGZyb20gJ3JhbWRhJztcbmltcG9ydCB7IFRoZW1lUHJvdmlkZXIgfSBmcm9tICdlbW90aW9uLXRoZW1pbmcnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgdGhlbWVHZXQgfSBmcm9tICdzdHlsZWQtc3lzdGVtJztcblxuaW1wb3J0ICdAaW5mbHVpdGl2ZS9pbmZsLWZvbnRzL2ZvbnRzLmNzcyc7XG5cbmltcG9ydCBtZXJnZWREZWZhdWx0cyBmcm9tICcuL2FsaWFzZXMnO1xuXG5jb25zdCBleHRlbmQgPSBSLnJlZHVjZShSLm1lcmdlRGVlcFJpZ2h0LCB7fSk7XG5cbmNvbnN0IHNpZGVzID0ge1xuICBhZG1pbjoge1xuICAgIGNvbG9yczoge1xuICAgICAgcHJpbWFyeTogJyMxODgzQzcnXG4gICAgfVxuICB9LFxuICBhZHZvY2F0ZToge1xuICAgIGNvbG9yczoge1xuXG4gICAgfVxuICB9XG59O1xuXG4vKiBzdHlsZWxpbnQtZGlzYWJsZSBmb250LWZhbWlseS1uby1taXNzaW5nLWdlbmVyaWMtZmFtaWx5LWtleXdvcmQgKi9cbmNvbnN0IEJhc2UgPSBzdHlsZWQoJ2RpdicpYFxuICAqLFxuICAqOjpiZWZvcmUsXG4gICo6OmFmdGVyIHtcbiAgICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICB9XG5cbiAgaHIge1xuICAgIGJveC1zaXppbmc6IGNvbnRlbnQtYm94O1xuICAgIGhlaWdodDogMDtcbiAgICBvdmVyZmxvdzogdmlzaWJsZTtcbiAgfVxuICBmb250LWZhbWlseTogJHt0aGVtZUdldCgnZm9udHMuZmFtaWx5LjAnKX0sIFwiQXBwbGUgQ29sb3IgRW1vamlcIiwgXCJTZWdvZSBVSSBFbW9qaVwiLCBcIlNlZ29lIFVJIFN5bWJvbFwiO1xuICBmb250LXNpemU6IDFyZW07XG4gIGZvbnQtd2VpZ2h0OiBub3JtYWw7XG4gIGxpbmUtaGVpZ2h0OiAxLjU7XG5cbiAgZGl2W2NsYXNzXj0nUGFnZV9fQ29udGFpbmVyLSddIHtcbiAgICB3aWR0aDogMTAwJSAhaW1wb3J0YW50O1xuICB9XG5gO1xuLyogc3R5bGVsaW50LWVuYWJsZSBmb250LWZhbWlseS1uby1taXNzaW5nLWdlbmVyaWMtZmFtaWx5LWtleXdvcmQgKi9cblxuZXhwb3J0IGRlZmF1bHQgKHsgdGhlbWUsIGNoaWxkcmVuLCB1c2VyID0gJ2Fkdm9jYXRlJyB9KSA9PlxuICA8VGhlbWVQcm92aWRlciB0aGVtZT17ZXh0ZW5kKFttZXJnZWREZWZhdWx0cywgc2lkZXNbdXNlcl0sIHRoZW1lIHx8IHt9XSl9PlxuICAgIDxCYXNlPlxuICAgICAge2NoaWxkcmVufVxuICAgIDwvQmFzZT5cbiAgPC9UaGVtZVByb3ZpZGVyPjtcbiJdfQ== */"));
/* stylelint-enable font-family-no-missing-generic-family-keyword */

var _default = function _default(_ref) {
  var theme = _ref.theme,
      children = _ref.children,
      _ref$user = _ref.user,
      user = _ref$user === void 0 ? 'advocate' : _ref$user;
  return (0, _core.jsx)(_emotionTheming.ThemeProvider, {
    theme: extend([_aliases.default, sides[user], theme || {}])
  }, (0, _core.jsx)(Base, null, children));
};

exports.default = _default;